import { ReactNode, useCallback, useState } from 'react';
import SubItem, { SubItemProps } from './SubItem';

type ListItemProps = {
  leftBorderColor?: string;
  children: ReactNode;
  subItems?: SubItemProps[] | SubItemProps;
  listItemStyle?: string;
  focused?: boolean;
  isActive?: boolean;
  connector?: boolean;
  connectorStyle?: string;
  onClick?: () => void;
  isOpen?: boolean;
  typeSubItemIsFaq?: boolean;
};

const ListItem = ({
  children,
  leftBorderColor = '',
  subItems = [],
  listItemStyle = '',
  focused,
  connector,
  connectorStyle = 'before:h-[calc(100%_-_31px)]',
  onClick,
  isOpen = false,
  typeSubItemIsFaq = false,
}: ListItemProps) => {
  const [showSubItems, setShowItems] = useState<boolean>(false);

  const handleShowSubItem = useCallback(() => {
    setShowItems((prev) => !prev);
    onClick?.();
  }, [onClick]);

  return (
    <div
      className="flex flex-row w-full cursor-pointer"
      onClick={handleShowSubItem}
    >
      <div
        className={`flex flex-col w-full relative mt-2 before:content-[''] before:absolute before:w-0.5 before:bg-[#616161] before:top-[1px]  ${connector ? connectorStyle : ''}`}
      >
        <div
          className={`flex flex-col border-l-[10px] border-l-[#232323] rounded-l-lg relative px-4 py-4  item left-[-5px] hover:bg-[#232323] hover:border-l-[#FEC200] ${focused ? 'bg-[#232323]' : 'bg-black'} ${listItemStyle} `}
          style={{ borderLeftColor: focused ? leftBorderColor : '' }}
        >
          <div
            className="text-white text-[15px] font-bold leading-4"
            style={{ wordBreak: 'break-word' }}
          >
            {children}
          </div>
        </div>

        <div
          className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
            isOpen || showSubItems ? 'max-h-[500px]' : 'max-h-0'
          }`}
        >
          {subItems && (
            <div className="flex flex-col ml-[60px]">
              {(Array.isArray(subItems) ? subItems : [subItems])?.map(
                (subItem, index) => (
                  <SubItem
                    key={index}
                    leftBorderColor={subItem.leftBorderColor}
                    children={subItem.children}
                    connector={subItem.connector}
                    typeSubItemIsFaq={typeSubItemIsFaq}
                  />
                ),
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListItem;